import Vue from "vue";
import Router from "vue-router";
import Routes from "./routes";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "*",
      redirect: "/"
    },
    {
      path: "/",
      name: Routes.mainRouter,
      component: require("@/pages/Home").default,
    },
    {
      path: `/convite/:token`,
      name: Routes.inviteRouter,
      component: require("@/pages/Invite").default,
    },
    {
      path: `/recarga/:token`,
      name: Routes.rechargeRouter,
      component: require("@/pages/Recharge").default,
    }
  ]
});
